import Sidebar from 'components/sidebar'
import { Layout } from '@tracklib/kit'
import ErrorBoundary from 'errorboundary'

import styles from './layout.css'

type SidebarWithMenuLayoutProps = {
  children?: JSX.Element
}

const SidebarWithMenuLayout = ({ children }: SidebarWithMenuLayoutProps): JSX.Element => {
  return (
    <Layout.SideBar className={styles.layout} sidebarContent={<Sidebar />}>
      <ErrorBoundary>{children}</ErrorBoundary>
    </Layout.SideBar>
  )
}

export default SidebarWithMenuLayout
